import { Component, OnInit } from '@angular/core';
import { SupportService } from '../services/support-service';
@Component({
  selector: 'app-patient-sidemenu',
  templateUrl: './patient-sidemenu.component.html',
})
export class PatientSidemenuComponent implements OnInit {
  year: any;
  constructor(public supportService: SupportService) {
    this.year = new Date().getFullYear();
  }

  ngOnInit() {}

  toggleSidemenu() {
    this.supportService.handlePatientHeader.next(false);
  }
}
